import React from 'react';
import { useSelector } from 'react-redux';
import { withRouter } from 'react-router-dom'

import { Fire, Tools } from '../../services'

import Switch from 'react-switch'
import { Headerbar, OnOff, FormInput, MyDateTimePicker, Select, Loader, YesNo, ConfirmLink, EditContainer, ImagesPicker } from '../Reusable'

import { ADS_MAKER_TYPE } from '../../types/types'

import FadeIn from 'react-fade-in';

const { useHistory } = require('react-router-dom')

const opts = [
  { value: 'normal', label: "20% - Taux normal", percentage: 20 },
  { value: 'reduit-high', label: "10% - Taux réduit", percentage: 10 },
  { value: 'reduit', label: "5.5% - Taux réduit", percentage: 5.5 },
  { value: 'super-reduit', label: "2.1% - Taux super réduit", percentage: 0.9 },
  { value: 'super-reduit-corse', label: "0.9% - Taux super réduit (Corse)", percentage: 0.9 },
]

const POPOUT_FEE = 10

interface Props {
  match: any;
}
const TicketingTicketScreen: React.FC<Props> = (props) => {

  const [error, setError] = React.useState('')
  const history = useHistory()
  const user = useSelector(state => state.authReducer.user)
  const elementId = props.match.params.elementId
  const elementRef = Fire.collection('ads').doc(elementId)

  const onFetch = async (id: string) => {
    try {
      const ref = elementRef.collection('tickets').doc(id)
      const ele = await Fire.doc(ref)
      ele.max_date = ele.max_date ? Fire.getDateFor(ele.max_date) : undefined
      return ele
    } catch (err) {
      setError("Impossible de charger le ticket")
      console.warn(err)
    }
    return null
  }

  const onSave = async (item: any, pictures: any[]) => {
    const data = {
      ...item,
      max: Number(item.max || 0),
      max_per_user: Number(item.max_per_user || 0),
      price: Number(item.price || 0),
    }

    try {
      if (item.id) {
        await elementRef.collection('tickets').doc(item.id).update(data)
      }
      else {
        const newItem = elementRef.collection('tickets').doc()
        data.createdAt = new Date()
        data.count = 0
        await newItem.set(data)
      }
      history.goBack()
    } catch (err) {
      setError("Impossible de modifier le ticket")
      console.warn(err)
    }
  }

  const updateErrors = (item: any) => {
    const errors: any = {}

    const price = Number(item.price || 0)
    if (user.type === ADS_MAKER_TYPE) {
      if (item.isFree || price < 1) {
        errors.price = 'Votre ticket doit avoir un prix minimum de 1€'
      }
    }

    return errors
  }

  const onRemove = async (item: any) => {
    try {
      await elementRef.collection('tickets').doc(item.id).delete()
      history.goBack()
    } catch (err) {
      setError("Impossible de supprimer le ticket")
      console.warn(err)
    }
  }

  const renderContent = ({item, onChange, save, saving, remove, changed, setChanged, errors}) => {
    return (
      <React.Fragment>
        <div className="card">
          <div className="card-header">
            <h3 className="card-title">Informations</h3>
          </div>
          <div className="card-body">
            <div className="item-add-form">
              <OnOff
                label="Activer"
                checked={item.active || false}
                onChange={(checked: boolean) => onChange('active', checked)}
                />
           
              <FormInput
                type="text"
                placeholder="Libellé du tarif"
                value={item.name}
                error={errors.name}
                onChange={(evt: any) => onChange('name', evt.target.value)}
              />

              <FormInput
                textarea
                rows={6}
                type="text"
                placeholder="Description"
                value={item.description}
                error={errors.description}
                onChange={(evt: any) => onChange('description', evt.target.value)}
                />

              <YesNo
                label="Gratuit"
                value={item.isFree || false}
                error={errors.isFree}
                onChange={(free) => onChange('isFree', free)}
                />

              { !item.isFree &&
                <div className="input-wrapper" style={{marginBottom: 6}}>
                  <Select
                    value={item.tax}
                    onChange={(tax) => onChange('tax', tax)}
                    options={opts}
                    placeholder='Choisir un taux de TVA...'
                    />
                </div>
              }

              { !item.isFree &&
                <FormInput
                  type="number"
                  placeholder="Prix fixe"
                  value={item.isFree ? '0' : item.price}
                  error={errors.price}
                  disabled={item.isFree}
                  onChange={(evt: any) => onChange('price', evt.target.value)}
                  />
              }

              { !item.isFree &&
                <div className="input-wrapper" style={{marginBottom: 6}}>
                  Gains après comission Pop Out: {Tools.renderPrice(item.price - (item.price * (POPOUT_FEE / 100)))}
                </div>
              }

              <FormInput
                type="number"
                placeholder="Nb. billets sélectionnables par personne"
                value={item.max_per_user}
                error={errors.max_per_user}
                onChange={(evt: any) => onChange('max_per_user', evt.target.value)}
                />

              <FormInput
                type="number"
                placeholder="Nb. billets total en vente"
                value={item.max}
                error={errors.max}
                onChange={(evt: any) => onChange('max', evt.target.value)}
                />

              <MyDateTimePicker
                dateTitle='Date maximum de vente'
                timeTitle=''
                date={item.max_date}
                onChange={(date) => onChange('max_date', date)}
                />
            </div>

            <div className="centered">
              <button
                type="button"
                className="btn btn-outline-primary"
                onClick={save}
                disabled={saving || !changed}
                >
                { saving ? 'Chargement...' : 'Enregistrer' }
              </button>
            </div>
          </div>
        </div>
        { item.id !== undefined &&
          <div className="centered">
            <ConfirmLink
              title='Supprimer'
              className='btn-remove'
              confirmTitle='Êtes-vous sûr de vouloir supprimer ce ticket ?'
              onPress={remove}
              />
          </div>
        }
      </React.Fragment>
    )
  }

  return (
    <EditContainer
      id={props.match.params.ticketId}
      error={error}
      updateErrors={updateErrors}
      defaultCreationValue={{
        tax: 'normal'
      }}

      onFetch={onFetch}
      onSave={onSave}
      onRemove={onRemove}
      renderContent={renderContent}
      />
  );
}

export default withRouter(TicketingTicketScreen)
